import TableRow from '@material-ui/core/TableRow';
import PropTypes from 'prop-types';
import React from 'react';
import ActionsCell from './ActionsCell';
import Header from './Header';
import useStyles from './HeaderGroup.styles';

const HeaderGroup = ({ headerGroup, hasActions, headerStyle }) => {
  const classes = useStyles();

  return (
    <TableRow classes={classes} style={headerStyle}>
      {headerGroup.headers.map((header) => {
        const { key, onClick } = header.getHeaderProps(header.getSortByToggleProps());
        return <Header key={key} header={header} onClick={onClick} />;
      })}

      {hasActions && <ActionsCell />}
    </TableRow>
  );
};

HeaderGroup.propTypes = {
  headerGroup: PropTypes.shape().isRequired,
  hasActions: PropTypes.bool,
  headerStyle: PropTypes.shape(),
};

HeaderGroup.defaultProps = {
  hasActions: false,
  headerStyle: undefined,
};

export default HeaderGroup;
